import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xl-9 order-2 order-xl-1" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white checkout-box letter-spacing" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("ul", {
  class: "nav nav-tabs bg-white border-0 rounded-0",
  id: "myTab",
  role: "tablist"
}, [
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100 active",
      id: "basic-information-tab",
      "data-bs-toggle": "tab",
      "data-bs-target": "#basic-information-tab-pane",
      type: "button",
      role: "tab",
      "aria-controls": "basic-information-tab-pane",
      "aria-selected": "true"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "flaticon-fingerprint-scan" }),
      /*#__PURE__*/_createTextVNode(" General ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100",
      id: "academic-information-tab",
      "data-bs-toggle": "tab",
      "data-bs-target": "#academic-information-tab-pane",
      type: "button",
      role: "tab",
      "aria-controls": "academic-information-tab-pane",
      "aria-selected": "false"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "flaticon-student-with-graduation-cap" }),
      /*#__PURE__*/_createTextVNode(" Educación ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100",
      id: "health-welfare-tab",
      "data-bs-toggle": "tab",
      "data-bs-target": "#health-welfare-tab-pane",
      type: "button",
      role: "tab",
      "aria-controls": "health-welfare-tab-pane",
      "aria-selected": "false"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "flaticon-industry" }),
      /*#__PURE__*/_createTextVNode(" Salud ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100",
      id: "additional-contract-tab",
      "data-bs-toggle": "tab",
      "data-bs-target": "#additional-contract-tab-pane",
      type: "button",
      role: "tab",
      "aria-controls": "additional-contract-tab-pane",
      "aria-selected": "false"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "flaticon-form" }),
      /*#__PURE__*/_createTextVNode(" Contrato ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100",
      id: "additional-emergency-tab",
      "data-bs-toggle": "tab",
      "data-bs-target": "#additional-emergency-tab-pane",
      type: "button",
      role: "tab",
      "aria-controls": "additional-emergency-tab-pane",
      "aria-selected": "false"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user" }),
      /*#__PURE__*/_createTextVNode(" Emergencia ")
    ])
  ])
], -1)
const _hoisted_7 = {
  class: "tab-content p-15 p-sm-20 p-md-25 p-lg-30",
  id: "myTabContent"
}
const _hoisted_8 = {
  class: "tab-pane fade show active",
  id: "basic-information-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_9 = {
  class: "tab-pane fade",
  id: "academic-information-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_10 = {
  class: "tab-pane fade",
  id: "health-welfare-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_11 = {
  class: "tab-pane fade",
  id: "additional-contract-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_12 = {
  class: "tab-pane fade",
  id: "additional-emergency-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_13 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "lh-1 me-1 position-relative top-2" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, "Cancelar", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing settings-card" }, null, -1)
const _hoisted_17 = { class: "col-lg-5 col-xl-3" }
const _hoisted_18 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing lead-info-box" }
const _hoisted_19 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_20 = { class: "profile-info d-sm-flex align-items-center" }
const _hoisted_21 = {
  class: "position-relative w-100",
  style: {"max-width":"280px"}
}
const _hoisted_22 = { class: "ratio ratio-1x1 rounded-circle overflow-hidden shadow-sm" }
const _hoisted_23 = ["src"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  for: "avatar-file",
  class: "btn btn-light border position-absolute d-flex align-items-center justify-content-center shadow file-upload text-center bg-white rounded-circle text-primary",
  style: {"width":"2px !important","height":"42px !important","right":"6px","bottom":"10px","z-index":"2","cursor":"pointer"}
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "flaticon-add-photo",
    style: {"font-size":"25px"}
  })
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "border-top mt-15 mb-15 mt-sm-20 mb-sm-20 mt-md-25 mb-md-25 mt-lg-30 mb-lg-30" }, null, -1)
const _hoisted_26 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_27 = { class: "fw-medium text-black-emphasis mb-0" }
const _hoisted_28 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_29 = { class: "title mt-12 mt-sm-0" }
const _hoisted_30 = { class: "d-block fs-md-15 fs-lg-16 text-dark-emphasis mb-8" }
const _hoisted_31 = { class: "d-block fw-bold text-primary" }
const _hoisted_32 = { class: "d-block fs-md-15 fs-lg-16 text-dark-emphasis mb-8" }
const _hoisted_33 = { class: "d-block fw-bold text-primary" }
const _hoisted_34 = { class: "info mt-25 ps-0 mb-0 list-unstyled" }
const _hoisted_35 = { class: "position-relative" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-success rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-mail-inbox-app" })
], -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, "Correo electrónico", -1)
const _hoisted_38 = {
  href: "mailto:johnathon23@gmail.com",
  class: "d-inline-block fs-md-15 fs-lg-16 text-primary text-decoration-none"
}
const _hoisted_39 = { class: "position-relative" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-info rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-telephone-call" })
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, "Telefono", -1)
const _hoisted_42 = {
  href: "tel:+1-321-456-8756",
  class: "d-inline-block fs-md-15 fs-lg-16 text-muted text-decoration-none"
}
const _hoisted_43 = { class: "position-relative" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-warning rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-industry" })
], -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, "EPS", -1)
const _hoisted_46 = { class: "d-inline-block fs-md-15 fs-lg-16 text-muted" }
const _hoisted_47 = { class: "position-relative" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-info rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-date-1" })
], -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, " Ultima fecha acta de posesión ", -1)
const _hoisted_50 = { class: "d-inline-block fs-md-15 fs-lg-16 text-muted" }
const _hoisted_51 = /*#__PURE__*/_createStaticVNode("<li class=\"position-relative\"><div class=\"icon text-warning rounded-circle text-center\"><i class=\"flaticon-status\"></i></div><span class=\"d-block text-black mb-5 fw-semibold\"> Estado </span><span class=\"badge text-outline-info\">Matriculado</span></li>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PersonelInformationComponent = _resolveComponent("PersonelInformationComponent")!
  const _component_TabAcademicComponent = _resolveComponent("TabAcademicComponent")!
  const _component_TabHealthComponent = _resolveComponent("TabHealthComponent")!
  const _component_TabContractComponent = _resolveComponent("TabContractComponent")!
  const _component_TabEmergencyComponent = _resolveComponent("TabEmergencyComponent")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_container = _resolveComponent("b-container")!
  const _component_b_form = _resolveComponent("b-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_b_form, {
              ref: "formRecord",
              id: "formModal",
              novalidate: "",
              onSubmit: _withModifiers(_ctx.handleSubmit, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_b_container, { fluid: "" }, {
                  default: _withCtx(() => [
                    _hoisted_6,
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_PersonelInformationComponent, {
                          record: _ctx.form.record,
                          "onUpdate:record": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.record) = $event)),
                          ref: "personRef",
                          wasValidated: _ctx.wasValidated
                        }, null, 8, ["record", "wasValidated"])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_TabAcademicComponent, {
                          record: _ctx.form.record,
                          "onUpdate:record": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.record) = $event)),
                          ref: "academicRef",
                          wasValidated: _ctx.wasValidated
                        }, null, 8, ["record", "wasValidated"])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_TabHealthComponent, {
                          record: _ctx.form.record,
                          "onUpdate:record": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.record) = $event)),
                          ref: "healthRef",
                          wasValidated: _ctx.wasValidated
                        }, null, 8, ["record", "wasValidated"])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_TabContractComponent, {
                          record: _ctx.form.record,
                          "onUpdate:record": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.record) = $event)),
                          ref: "contractRef",
                          wasValidated: _ctx.wasValidated
                        }, null, 8, ["record", "wasValidated"])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_TabEmergencyComponent, {
                          record: _ctx.form.record,
                          "onUpdate:record": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.record) = $event)),
                          ref: "emergencyRef",
                          wasValidated: _ctx.wasValidated
                        }, null, 8, ["record", "wasValidated"])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_b_button, {
                          class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                          type: "submit"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.form.record.Id ? 'Guardar cambios' : 'Agregar docente'), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_b_button, {
                          onClick: _ctx.cancel,
                          class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_14,
                            _hoisted_15
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onSubmit"])
          ])
        ])
      ]),
      _hoisted_16
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("img", {
                  src: _ctx.previewUrl,
                  alt: "Foto",
                  class: "w-100 h-100 object-fit-cover d-block"
                }, null, 8, _hoisted_23)
              ]),
              _createElementVNode("input", {
                id: "avatar-file",
                type: "file",
                accept: "image/*",
                class: "visually-hidden",
                onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args)))
              }, null, 32),
              _hoisted_24
            ])
          ]),
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("h6", _hoisted_27, _toDisplayString(`${_ctx.form.record?.Name} ${_ctx.form.record?.LastName}`), 1)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("span", _hoisted_30, [
                _createElementVNode("label", _hoisted_31, " SEDE: " + _toDisplayString(`${_ctx.GetHeadquarter()}`), 1)
              ]),
              _createElementVNode("span", _hoisted_32, [
                _createElementVNode("label", _hoisted_33, " JORNADA: " + _toDisplayString(`${_ctx.GetJourney()}`), 1)
              ])
            ])
          ]),
          _createElementVNode("ul", _hoisted_34, [
            _createElementVNode("li", _hoisted_35, [
              _hoisted_36,
              _hoisted_37,
              _createElementVNode("a", _hoisted_38, _toDisplayString(_ctx.form.record?.WorkEmail || _ctx.form.record?.PersonalEmail), 1)
            ]),
            _createElementVNode("li", _hoisted_39, [
              _hoisted_40,
              _hoisted_41,
              _createElementVNode("a", _hoisted_42, _toDisplayString(_ctx.form.record?.PrimaryPhone || _ctx.form.record?.SecondaryPhone), 1)
            ]),
            _createElementVNode("li", _hoisted_43, [
              _hoisted_44,
              _hoisted_45,
              _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.form.record?.NameIps || ''), 1)
            ]),
            _createElementVNode("li", _hoisted_47, [
              _hoisted_48,
              _hoisted_49,
              _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.form.record?.DateLastActPossession || ''), 1)
            ]),
            _hoisted_51
          ])
        ])
      ])
    ])
  ]))
}